// extracted by mini-css-extract-plugin
var _1 = "ProfilePermission_inputField__zFgXl";
var _2 = "ProfilePermission_lineContent__mwQxI";
var _3 = "ProfilePermission_lineName__O8B+L";
var _4 = "ProfilePermission_note__-QeuQ";
var _5 = "ProfilePermission_profileWalletContainer__aFukl";
var _6 = "ProfilePermission_profileWalletLine__5-kq+";
export { _1 as "inputField", _2 as "lineContent", _3 as "lineName", _4 as "note", _5 as "profileWalletContainer", _6 as "profileWalletLine" }
